import { render, staticRenderFns } from "./EntityThumbWrapper.vue?vue&type=template&id=f8758fbe&scoped=true&"
import script from "./EntityThumbWrapper.vue?vue&type=script&lang=js&"
export * from "./EntityThumbWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8758fbe",
  null
  
)

export default component.exports